import {
  GET_SITESURVEYS,
  GET_SITESURVEYS_SUCCESS,
  GET_SITESURVEYS_FAIL,
  ADD_SITESURVEY,
  ADD_SITESURVEY_SUCCESS,
  ADD_SITESURVEY_FAIL,
  UPDATE_SITESURVEY,
  UPDATE_SITESURVEY_SUCCESS,
  UPDATE_SITESURVEY_FAIL,
  DELETE_SITESURVEY,
  DELETE_SITESURVEY_SUCCESS,
  DELETE_SITESURVEY_FAIL,
  SET_SITESURVEY_FIELD_ERRORS,
} from './actionTypes'

const initialState = {
  sitesurveys: [],
  loading: false,
  error: null,
  status: null,
  fieldErrors: {}, // Store field-specific errors
}

const workOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SITESURVEYS:
      return { ...state, loading: true }
    case GET_SITESURVEYS_SUCCESS:
      return { ...state, loading: false, sitesurveys: action.payload, error: null }
    case GET_SITESURVEYS_FAIL:
      return { ...state, loading: false, error: action.payload }

    case ADD_SITESURVEY:
      return { ...state, loading: true }
    case ADD_SITESURVEY_SUCCESS:
      return { ...state, loading: false, status: 'success', fieldErrors: {} }
    case ADD_SITESURVEY_FAIL:
      return { ...state, loading: false, error: action.payload }

    case UPDATE_SITESURVEY:
      return { ...state, loading: true }
    case UPDATE_SITESURVEY_SUCCESS:
      return { ...state, loading: false, fieldErrors: {} }
    case UPDATE_SITESURVEY_FAIL:
      return { ...state, loading: false, error: action.payload }

    case DELETE_SITESURVEY:
      return { ...state, loading: true }
    case DELETE_SITESURVEY_SUCCESS:
      return { ...state, loading: false }
    case DELETE_SITESURVEY_FAIL:
      return { ...state, loading: false, error: action.payload }

    case SET_SITESURVEY_FIELD_ERRORS:
      return { ...state, fieldErrors: action.payload }

    default:
      return state
  }
}

export default workOrderReducer
